<template>
  <div class="loading flex-container flex-column flex-horiz-center flex-verti-center">
    <div class="main flex-container flex-column flex-horiz-center">
      <img class="pic" :src="loadingSvg" alt="">
      <span class="text">正在加载内容......</span>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import LoadingG from '@/assets/image/loading-green.svg'
import LoadingB from '@/assets/image/loading-blue.svg'
export default {
  computed: {
    ...mapGetters({
      platform: 'platform'
    }),
    loadingSvg() {
      return this.platform === 'g' ? LoadingB : LoadingG
    }
  },
}
</script>

<style lang="less" scoped>
.loading{
  width: 100%;
  height: 100%;
  background: rgba(229, 231, 235, 0.5);
  position: absolute;
  top: 0;left: 0;right: 0;bottom: 0;
  z-index: 100;
}
.text{
  color: #666666;
}

</style>
